import type { TUserType } from '../types/user';

const UserTypes: Record<TUserType, string> = {
  REGULAR: 'userTypes.REGULAR',
  STAFF: 'userTypes.STAFF',
  SUPPLIER: 'userTypes.SUPPLIER',
  API: 'userTypes.API',
  OPERATOR: 'userTypes.OPERATOR'
};

export const UserTypesIcons: Record<TUserType, string> = {
  REGULAR: 'person-outline',
  STAFF: 'key-outline',
  SUPPLIER: 'storefront-outline',
  API: 'hardware-chip-outline',
  OPERATOR: 'build-outline'
};

export const BasicUserTypes: TUserType[] = ['REGULAR', 'SUPPLIER', 'OPERATOR'];

export const UserTypesOptions: TSelectOption[] = (Object.keys(UserTypes) as TUserType[]).map(
  (key: TUserType) => {
    return { key, label: UserTypes[key], icon: UserTypesIcons[key] };
  }
);

export default UserTypes;
